import React from "react";
import translate from "../../service/Language";
import Currency from "../../service/Currency";
import classes from "./Products.module.css";
import products from "../../products/products";
import { Link } from "react-router-dom";

function Products({ GetHome }) {
  return (
    <div className={classes.Products} id="catalog">
      {products ? (
        products.map((item, index) => (
          <Link
            onClick={(e) => {
              GetHome();
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
              });
            }}
            to={`/more/${item.id}`}
            className={classes.product}
            key={index}
          >
            <div className={classes.image}>
              <img src={item.images[0].img} alt="" />
            </div>
            <h3>{translate(item.title_ru, item.title_uz)}</h3>
            <p>{translate(item.desc_ru, item.desc_uz)}</p>
            <div className={classes.prices}>
              <h4>{Currency(item.price)} UZS</h4>{" "}
              <span>
                {item.oldPrice ? Currency(item.oldPrice) + " UZS" : ""}
              </span>
            </div>
          </Link>
        ))
      ) : (
        <h2>Loading...</h2>
      )}
    </div>
  );
}

export default Products;
